/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import InnerContent from "./InnerContent/InnerContent";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { saveUserDetails } from "store/reducers/UserDetails/UserDetailsSlice";
const useStyles = makeStyles((theme) => ({
 mainContainer: {
    width: "100%",
    position:'relative',
    height:'100vh',
    '& [class*="PrivateHiddenCss-mdUp-14"]':{
      width:'100%'
    }
  },
}));
const MainContainer = ({onReload, key, branchName, setBranchName, notifications, setNotifications}) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [showSidebar, setShowSidebar] = React.useState(true);
  const { authToken } = useSelector((state) => state.login.authData);
  const [roleUser, setRoleUser] = useState("");
  const [designation, setDesignation] = useState("");
  const [rootHierarchy, setRootHierarchy] = useState(false);
  const [callInProgress, setCallInProgress] = useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleSidebarToggle = () => {
    setShowSidebar(!showSidebar);
  };
  const [outletData, setOutletData] = useState({});
  const [userDetailsData, setUserDetailsData]=useState({})
    const dispatch = useDispatch()
  
  useEffect(() => {
    getFeatureFlag();
    getUserDetails();
  }, []);
  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    setOutletData(result?.data);
  };

  const getUserDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_DETAIL,
      authToken: authToken,
    });
    setCallInProgress(false);
    setRoleUser(result?.data?.role);
    setDesignation(result?.data?.designation);
    setRootHierarchy(result?.data?.rootHierarchy);
    setUserDetailsData(result?.data)
     dispatch(
          saveUserDetails({
            userDetails: result?.data,
          })
        );
  };
  const classes = useStyles();
  return (
    <div className={classes.mainContainer}>
      <Header
        handleDrawerToggle={handleDrawerToggle}
        handleSidebarToggle={handleSidebarToggle}
        userDetailsData={userDetailsData}
        onReload={onReload}
        key={key}
        branchName={branchName}
        setBranchName={setBranchName}
        outletData={outletData}
        notifications={notifications}
        setNotifications={setNotifications}
      />
      <InnerContent
        handleSidebarToggle={handleSidebarToggle}
        handleDrawerToggle={handleDrawerToggle}
        mobileOpen={mobileOpen}
        roleUser={roleUser}
        designation={designation}
        rootHierarchy={rootHierarchy}
        outletData={outletData}
      />
      <Footer />
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

export default MainContainer;
